import { anyOf, arrayOf, enumOf, objectOf, recordOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, string, number } from "@altostra/type-validations/lib/primitives";

import sharedConstants from "@lib/shared_constants";

export const isWorkflowAttributeAllowedValue = objectOf({
  value: anyOf(string, number, boolean),
  description: string,
});

export const isWorkflowAttributeDefinitionResultObject = objectOf({
  id: string,
  type: enumOf("workflow_attribute"),
  name: string,
  description: string,
  data_type: enumOf(...sharedConstants.CONVERSATION_TOOL_DEFINITION.DATA_TYPES),
  allowed_values: arrayOf(isWorkflowAttributeAllowedValue),
  created_at: string,
  updated_at: string,
  created_by_email: string,
});

export const isWebhookVariable = objectOf({
  name: string,
  data_type: enumOf(...sharedConstants.CONVERSATION_TOOL_DEFINITION.DATA_TYPES),
  source: enumOf(...sharedConstants.CONVERSATION_TOOL_DEFINITION.WEBHOOK.VARIABLE_SOURCES),
  source_id: anyOf(string, nullOrUndefined),
  description: anyOf(string, nullOrUndefined),
  required: boolean,
});

export const isWebhookResponseField = objectOf({
  name: string,
  path: string,
  description: string,
});

export const isWebhookDefinitionResultObject = objectOf({
  id: string,
  type: enumOf("webhook"),
  name: string,
  description: string,
  request_method: enumOf(...sharedConstants.CONVERSATION_TOOL_DEFINITION.WEBHOOK.REQUEST_METHODS),
  url: string,
  body: anyOf(string, nullOrUndefined),
  headers: recordOf(string),
  credential_name: anyOf(string, nullOrUndefined),
  variables: arrayOf(isWebhookVariable),
  response_fields: arrayOf(isWebhookResponseField),
  created_at: string,
  updated_at: string,
  created_by_email: string,
});

export const isConversationalToolDefinitionResultObject = anyOf(
  isWorkflowAttributeDefinitionResultObject,
  isWebhookDefinitionResultObject
);

export const isConversationalToolDefinitionIdResult = objectOf({
  result: isConversationalToolDefinitionResultObject,
});
